export default function MisionVision() {
  return (
    <section className="mision-vision">
      <div className="container">
        <div className="mv-side-grid">
          <div className="mv-side-label">
            <p className="section-overline" style={{ justifyContent: 'flex-start', margin: 0 }}>Nuestra empresa</p>
            <h2 className="section-title dark" style={{ textAlign: 'left', marginTop: '12px' }}>
              Misión<br />y Visión
            </h2>
            <div className="section-divider" style={{ margin: '18px 0 0' }} />
          </div>

          <div className="mv-side-cards">
            <div className="mv-side-card">
              <div className="mv-side-tag">Misión</div>
              <p className="mv-side-text">
                Distribuir materiales de acero de calidad al mejor precio del mercado,
                ofreciendo a constructores, herreros y talleres de Tepatitlán y la región
                una opción accesible, confiable y con la asesoría que cada proyecto necesita.
              </p>
            </div>
            <div className="mv-side-card">
              <div className="mv-side-tag">Visión</div>
              <p className="mv-side-text">
                Consolidarnos como la distribuidora de acero más accesible y reconocida
                de Tepatitlán de Morelos, expandiendo nuestro catálogo y cobertura para
                que más clientes puedan construir y fabricar a mejor costo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
